// extracted by mini-css-extract-plugin
module.exports = {"app-container":"app-container--3dSXo","appContainer":"app-container--3dSXo"};